import { Inject, Injectable, OnDestroy, Optional, inject } from '@angular/core';
import { JsonLdScriptFactory } from './json-ld-script.factory';
import { SCHEMA_BUILDER } from './tokens';
import { SchemaBuilder } from './structured-data.model';
import { combineLatest, Observable, Subscription } from 'rxjs';

@Injectable()
export class StructuredDataFactory implements OnDestroy {
  private scriptBuilder = inject(JsonLdScriptFactory);

  constructor(
    @Optional() @Inject(SCHEMA_BUILDER) private builders: SchemaBuilder[],
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected subscription: Subscription = new Subscription();

  /**
   * Initiates the build of structured data by collecting all schema
   * builders.
   */
  build(): void {
    if (this.builders) {
      this.subscription.add(
        this.collectSchemas().subscribe((schema: object[]) => {
          return this.scriptBuilder.build(schema);
        }),
      );
    }
  }

  /**
   * Collects all schema builders and observe their structured data.
   */
  protected collectSchemas(): Observable<any[]> {
    return combineLatest(this.builders.map((builder) => builder.build()));
  }
}
